import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { DisbursementStatus } from '@percent/admin-dashboard/api/actions/disbursements/disbursements.types'
import { DisbursementsBreakdownQueryParams } from './DisbursementsBreakdownFilters.types'

type UseStatusFilterProps = {
  queryParams: DisbursementsBreakdownQueryParams
  setQueryParams: (queryParams: DisbursementsBreakdownQueryParams) => void
  includeMultiApprovalStatuses: boolean
}

export const useStatusFilter = ({
  queryParams,
  setQueryParams,
  includeMultiApprovalStatuses
}: UseStatusFilterProps) => {
  const { t } = useTranslation()

  const statusesOptions = [
    { label: t('status.pendingApproval'), value: DisbursementStatus.PENDING_APPROVAL },
    ...(includeMultiApprovalStatuses
      ? [
          { label: t('status.pendingFoundationApproval'), value: DisbursementStatus.PENDING_TRUSTEE_APPROVAL },
          { label: t('status.pendingAgentApproval'), value: DisbursementStatus.PENDING_AGENT_APPROVAL },
          { label: t('status.pendingManagerApproval'), value: DisbursementStatus.PENDING_MANAGER_APPROVAL }
        ]
      : []),
    { label: t('status.pendingPayment'), value: DisbursementStatus.PENDING_PAYMENT },
    ...(includeMultiApprovalStatuses
      ? [{ label: t('status.paymentInitiated'), value: DisbursementStatus.PAYMENT_INITIATED }]
      : []),
    { label: t('status.sent'), value: DisbursementStatus.SENT },
    { label: t('status.paid'), value: DisbursementStatus.PAID },
    { label: t('status.paymentReturned'), value: DisbursementStatus.RETURNED },
    ...(includeMultiApprovalStatuses ? [{ label: t('status.failed'), value: DisbursementStatus.FAILED }] : []),
    { label: t('status.removed'), value: DisbursementStatus.CANCELLED }
  ]

  const onStatusChange = useCallback(
    (statuses: string[]) => {
      setQueryParams({ ...queryParams, status: statuses })
    },
    [queryParams, setQueryParams]
  )

  return {
    statusesOptions,
    onStatusChange,
    selectedStatuses: queryParams?.status ?? []
  }
}
